import { useQuery } from '@tanstack/react-query';

import { getProfile } from '@/services/courier';

export const PROFILE_KEY = ['me'] as const;

export function useProfile() {
  return useQuery({ queryKey: PROFILE_KEY, queryFn: getProfile, staleTime: 5 * 60_000 });
}
